/**
 * Created by griga on 7/11/16.
 */


import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from "./shared/layout/app-layouts/main-layout.component";
import { AuthLayoutComponent } from "./shared/layout/app-layouts/auth-layout.component";
import { ModuleWithProviders } from "@angular/core";
import { AuthGuard } from './+auth/auth-guard';

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        data: { pageTitle: 'Home' },
        children: [
            {
                path: 'home',
                loadChildren: 'app/+home/home.module#HomeModule',
                data: { pageTitle: 'Client Home' }
            },
            {
                path: 'contactExxon',
                loadChildren: 'app/+contact-us/contact-us.module#ContactUsModule',
                data: { pageTitle: 'Contact Us' }
            },
            {
                path: 'contactLaLa',
                loadChildren: 'app/+contact-lala/contact-lala.module#ContactLaLaModule',
                data: { pageTitle: 'Contact Us' }
            },
            {
                path: 'contactShopt',
                loadChildren: 'app/+contact-shopt/contact-shopt.module#ContactShoptModule',
                data: { pageTitle: 'Contact Us' }
            },
            {
                path: 'myAccount',
                loadChildren: 'app/+myaccount/myaccount.module#MyAccountModule',
                data: { pageTitle: 'My Account' }
            },
            {
                path: 'contactFerrara',
                loadChildren: 'app/+contact-us-ferrara/contact-us-ferrara.module#ContactUsFerraraModule',
                data: { pageTitle: 'Contact Us' }
            },
            {
                path: 'eventsCalendar',
                loadChildren: 'app/+events-calendar/events-calendar.module#EventsCalendarModule',
                data: { pageTitle: 'Events Calendar' }
            },
            {
                path: 'admin',
                loadChildren: 'app/+admin/admin.module#AdminModule',
                data: { pageTitle: 'Admin' }
            },
            {
                path: 'mycampaigns',
                loadChildren: 'app/+mycampaigns/mycampaigns.module#MyCampaignsModule',
                data: { pageTitle: 'My Campaigns' }
            },
            {
                path: 'campaign-library',
                loadChildren: 'app/+campaign-library/campaign-library.module#CampaignLibraryModule',
                data: { pageTitle: 'Campaign Library' }
            },
            {
                path: 'myplanner',
                loadChildren: 'app/+my-planner/my-planner.module#MyPlannerModule',
                data: { pageTitle: 'My Planner' }
            },
            {
                path: 'tactic-catalog',
                loadChildren: 'app/+tactic-catalog/tactic-catalog.module#TacticCatalogModule',
                data: { pageTitle: 'Tactic Catalog' }
            },
            {
                path: 'assets',
                loadChildren: 'app/+assets/assets.module#AssetsModule',
                data: { pageTitle: 'Assets' }
            },
            {
                path: 'assets/:type',
                loadChildren: 'app/+assets/assets.module#AssetsModule',
                data: { pageTitle: 'Assets' }
            },
            {
                path: 'smartadmin',
                loadChildren: 'app/+smartadmin-intel/smartadmin-intel.module#SmartadminIntelModule',
                data: { pageTitle: 'Smartadmin' }
            },
            {
                path: 'app-views',
                loadChildren: 'app/+app-views/app-views.module#AppViewsModule',
                data: { pageTitle: 'App Views' }
            },
            {
                path: 'miscellaneous',
                loadChildren: 'app/+miscellaneous/miscellaneous.module#MiscellaneousModule',
                data: { pageTitle: 'Miscellaneous' }
            },
            {
                path: '', redirectTo: 'home', pathMatch: 'full'
            },
            {
                path: 'productionprocessing',
                loadChildren: 'app/+productionprocessing/productionprocessing.module#ProductionProcessingModule',
                data: { pageTitle: 'Production Processing' }
            },
            {
                path: 'brandssummary',
                loadChildren: 'app/+brands-summary/brands-summary.module#BrandsSummaryModule',
                data: { pageTitle: 'Brands Summary' }
            },
            {
                path: 'brandallocation/:id',
                loadChildren: 'app/+brand-allocation/brand-allocation.module#BrandAllocationModule',
                data: { pageTitle: 'Target Allocation' }
            },
            {
                path: 'retailersummary',
                loadChildren: 'app/+retailer-overview/retailer-overview.module#RetailerOverviewModule',
                data: { pageTitle: 'Retailer Summary' }
            },
            {
                path: 'programoverview/:retailerId/:brandId/:budgetYear',
                loadChildren: 'app/+program-overview/program-overview.module#ProgramOverviewModule',
                data: { pageTitle: 'Program Summary' }
            },
            {
                path: 'programdetails/:id',
                loadChildren: 'app/+program-details/program-details.module#ProgramDetailsModule',
                data: { pageTitle: 'Program Details' }
            },
            {
                path: 'expensemangement/po',
                loadChildren: 'app/+expensemanagementpo/expensemanagementpo.module#ExpensesManagmentPoModule',
                data: { pageTitle: 'Expenses Po' }
            },
            {
                path: 'expensemangement/do',
                loadChildren: 'app/+expensemanagementdo/expensemanagementdo.module#ExpensesManagmentDoModule',
                data: { pageTitle: 'Expenses Do' }
            },
            {
                path: 'expensemangement/journalentries',
                loadChildren: 'app/+expensemanagementjournalentries/expensemanagementjournalentries.module#ExpensesManagmentJournalModule',
                data: { pageTitle: 'Expenses Journal Entries' }
            },
            {
                path: 'expensemangement/coupon',
                loadChildren: 'app/+expensemanagementcoupon/expensemanagementcoupon.module#ExpensesManagmentCouponModule',
                data: { pageTitle: 'Expenses Do' }
            },
            {
                path: 'expensemangement/promo',
                loadChildren: 'app/+expensemanagementpromo/expensemanagementpromo.module#ExpensesManagmentPromoModule',
                data: { pageTitle: 'Expenses Promo' }
            },
            {
                path: 'expensemangement/mindshare',
                loadChildren: 'app/+expensemanagementmindshare/expensemanagementmindshare.module#ExpensesManagmentMindShareModule',
                data: { pageTitle: 'Expenses Mindshare' }
            },
            {
                path: 'promocoderequest/:id',
                loadChildren: 'app/+promocoderequest/promocoderequest.module#ProgramRequestModule',
                data: { pageTitle: 'Program Request' }
            },
            {
                path: 'messages',
                loadChildren: './+messages/messages.module#MessagesModule',
                data: { pageTitle: 'Messages' }
            },
            {
                path: 'promo/reconciliation/:id',
                loadChildren: './+promo-reconciliation/promo-reconciliation.module#PromoReconciliationModule',
                data: { pageTitle: 'Promo Reconciliation' }
            },
            {
                path: 'po/reconciliation/:id',
                loadChildren: './+po-reconciliation/po-reconciliation.module#PoReconciliationModule',
                data: { pageTitle: 'Po Reconciliation' }
            },
            {
                path: 'coupon/reconciliation/:id',
                loadChildren: './+coupon-reconciliation/coupon-reconciliation.module#CouponReconciliationModule',
                data: { pageTitle: 'Coupon Reconciliation' }
            },
            {
                path: 'do/reconciliation/:id',
                loadChildren: './+do-reconciliation/do-reconciliation.module#DoReconciliationModule',
                data: { pageTitle: 'Do Reconciliation' }
            },
            {
                path: 'wirereport',
                loadChildren: './+wirereport/wirereport.module#WirereportModule',
                data: { pageTitle: 'Wire Report' }
            },
            {
                path: 'campaign-library/:id',
                loadChildren: 'app/+campaign-library-program/campaign-library.module#CampaignLibraryProgramModule',
                data: { pageTitle: 'Campaign Library' }
            },
            {
                path: 'dashboard',
                loadChildren: 'app/+mydashboard/mydashboard.module#MyDashBoardModule',
                data: { pageTitle: 'Dashboard' }
            },
            {
                path: 'guidelines',
                loadChildren: 'app/+guidelines/guidelines.module#GuidelinesModule',
                data: { pageTitle: 'Guidelines' }
            },
            {
                path: 'resources',
                loadChildren: 'app/+resources/resources.module#ResourcesModule',
                data: { pageTitle: 'Resources' }
            },
            {
                path: 'reporting',
                loadChildren: 'app/+reports/reports.module#ReportsModule',
                data: { pageTitle: 'Reports' }
            },
            {
                path: 'communicationrequest',
                loadChildren: 'app/+communication-request/communication-request.module#ComunicationRequestModule',
                data: { pageTitle: 'Communication Request' }
            },
            {
                path: 'communicationrequest/:id',
                loadChildren: 'app/+communication-request-detail/communication-request-detail.module#ComunicationRequestDetailsModule',
                data: { pageTitle: 'Communication Request' }
            },
            {
                path: 'program-status',
                loadChildren: 'app/+program-status/program-status.module#ProgramStatusModule',
                data: { pageTitle: 'Program Status' }
            },
            {
                path: 'tactic-catalog/:programid/customize/2',
                loadChildren: 'app/+program-customize/program-customize.module#ProgramCustomizeDetailsModule',
                data: { pageTitle: 'Program Customization' }
            },
            {
                path: 'retailerprofile',
                loadChildren: 'app/+retailerprofile/retailerprofile.module#RetailerProfileModule',
                data: { pageTitle: 'Retailer Profile' }
            },
            {
                path: 'retailerprofileownerresident',
                loadChildren: 'app/+retailerprofileownersresident/retailerprofileownersresident.module#RetailerProfileOwnerResidentModule',
                data: { pageTitle: 'Retailer Profile' }
            },
            {
                path: 'retailerprofiledocumentlib',
                loadChildren: 'app/+retailerprofiledocumentlib/retailerprofiledocumentlib.module#RetailerProfileDocumentLibModule',
                data: { pageTitle: 'Retailer Profile' }
            },
            {
                path: 'addressbook',
                loadChildren: 'app/+addressbook/addressbook.module#AddressBookModule',
                data: { pageTitle: 'My Address Book' }
            },
        ]
    },

    { path: 'auth', component: AuthLayoutComponent, loadChildren: 'app/+auth/auth.module#AuthModule' },
    { path: 'auth-callback', component: AuthLayoutComponent, loadChildren: 'app/+auth-callback/auth-callback.module#AuthCallbackModule' },
    { path: '**', redirectTo: 'miscellaneous/error404' },

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts